<template>
	<div class="list-box py-4 px-3 lg:px-4 bg-bg-003">
		<header class="pb-4 text-red border-b border-gray-004">
			<span class="text-small font-bold uppercase">{{ title }}</span>
		</header>
		<section
			:class="{
				'grid': isGrid,
				'grid-cols-12': isGrid,
				'gap-3': isGrid,
				'mt-3': isGrid
			}"
		>
			<div 
				v-for="(item, ndx) in list"
				:key="`list_${ ndx }`"
				:class="{
					'col-span-12': isGrid,
					'md:col-span-6': isGrid && rows === 2,
					'md:col-span-4': isGrid && rows === 3,
					'md:col-span-3': isGrid && rows === 4,
					'py-5': !isGrid,
					'lg:py-4': !isGrid,
					'border-b': needsBorder && (ndx + 1) !== list.length,
					'border-gray-004': needsBorder && (ndx + 1) !== list.length,
				}"
			>
				<component
					:is="listComponent"
					:id="item.articleid"
					:img-url="item.thumbnail"
					:headline="item.hed"
					:subhead="item.dek"
					:date="item.releasedate ? formatTimestamp(item.releasedate) : null"
					:author="item.author"
					:body="item.body ? truncateString(item.body, 25) : null"
					:href="baseUrl + 'activities/' + item.articleid"
					:fields="fields"
				/>
			</div>
		</section>
	</div>
</template>

<script>
import globalMixins from '@/mixins/global-mixins'

import ListItem from '@/components/list/Item'
import ListCard from '@/components/list/Card'

export default {
	name: 'ListBox',
	components: {
		ListItem,
		ListCard
	},
	mixins: [
		globalMixins
	],
	props: {
		title: {
			type: String,
			default: 'Title'
		},
		list: {
			type: Array,
			default: () => []
		},
		type: {
			type: String,
			default: 'item'
		},
		border: {
			type: Boolean,
			default: true
		},
		rows: {
			type: Number,
			default: 3
		},
		fields: {
			type: [String, Array],
			default: 'all'
		}
	},
	computed: {
		listComponent() {
			return 'List' + this.type.charAt(0).toUpperCase() + this.type.slice(1)
		},
		needsBorder() {
			return this.border && this.type === 'item'
		},
		isGrid() {
			return this.type === 'card'
		}
	}
}
</script>